/** Overlay → game audio hook (buttons click, stars chime) without the UI importing services. */
let sink: ((name: string, step?: number) => void) | null = null;

export function setUiSound(fn: (name: string, step?: number) => void): void {
  sink = fn;
}

export function uiSound(name: string, step?: number): void {
  sink?.(name, step);
}
